import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetValidatedTenantsForRoleQueryVariables = Types.Exact<{
  role: Types.TenantRole;
  inputValue?: Types.InputMaybe<Types.Scalars['String']>;
  approvalStatus?: Types.InputMaybe<Types.ApprovalStatus>;
}>;


export type GetValidatedTenantsForRoleQuery = { __typename?: 'Query', tenants?: { __typename?: 'TenantCollectionSegment', items?: Array<{ __typename?: 'Tenant', id: string, tenantName: string, tenantRole: Types.TenantRole, approvalStatus: Types.ApprovalStatus }> | null } | null };


        export type ExecGetValidatedTenantsForRoleOptions = Omit<
        Apollo.QueryOptions<
        GetValidatedTenantsForRoleQueryVariables, GetValidatedTenantsForRoleQuery
        >,
        "query"
      >;
    export const execGetValidatedTenantsForRoleQuery = (options: ExecGetValidatedTenantsForRoleOptions) =>
    client.query< GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>({
      ...options,
      query: GetValidatedTenantsForRoleDocument,
    });
    

export const GetValidatedTenantsForRoleDocument = gql`
    query getValidatedTenantsForRole($role: TenantRole!, $inputValue: String, $approvalStatus: ApprovalStatus) {
  tenants(
    where: {tenantName: {contains: $inputValue}, approvalStatus: {neq: $approvalStatus}, tenantRole: {eq: $role}}
  ) {
    items {
      id
      tenantName
      tenantRole
      approvalStatus
    }
  }
}
    `;

/**
 * __useGetValidatedTenantsForRoleQuery__
 *
 * To run a query within a React component, call `useGetValidatedTenantsForRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidatedTenantsForRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidatedTenantsForRoleQuery({
 *   variables: {
 *      role: // value for 'role'
 *      inputValue: // value for 'inputValue'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useGetValidatedTenantsForRoleQuery(baseOptions: Apollo.QueryHookOptions<GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>(GetValidatedTenantsForRoleDocument, options);
      }
export function useGetValidatedTenantsForRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>(GetValidatedTenantsForRoleDocument, options);
        }
export type GetValidatedTenantsForRoleQueryHookResult = ReturnType<typeof useGetValidatedTenantsForRoleQuery>;
export type GetValidatedTenantsForRoleLazyQueryHookResult = ReturnType<typeof useGetValidatedTenantsForRoleLazyQuery>;
export type GetValidatedTenantsForRoleQueryResult = Apollo.QueryResult<GetValidatedTenantsForRoleQuery, GetValidatedTenantsForRoleQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;